import { MenuItem } from "@material-ui/core";
import React from "react";

export default function useUf() {
    const options = React.useMemo(() => [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO'
    ], []);

    const getOptions = React.useCallback(() => {
        return options;
    }, [options]);

    const createOptions = React.useCallback(() => {
        return options.map((option, index) => <MenuItem key={index} value={option}>{option}</MenuItem>);
    }, [options]);

    return React.useMemo(() => ({
        getOptions, createOptions
    }), [getOptions, createOptions])
}